import { useQuery } from 'react-query';
import useAbortController from 'hooks/useAbortController';
import { getVehicleModels } from 'services/householdService';

const useGetVehicleModelsQuery = ({ options, makeId } = {}) => {
  const abortControllerOptions = useAbortController();
  const queryKey = ['getVehicleModels', makeId];

  const query = useQuery(
    queryKey,
    async () => await getVehicleModels(makeId, abortControllerOptions),
    {
      enabled: Boolean(makeId?.length > 0),
      ...options,
    },
  );
  return { ...query, models: query?.data ?? [] };
};

export default useGetVehicleModelsQuery;
